module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "List"
  }, [_c('div', [_c('div', [_c('swiper', {
    attrs: {
      "height": 462 / 40 + 'rem',
      "no-arrow": true,
      "autoplay": 2000,
      "complete": _vm.complete,
      "pagination-title": 'test'
    }
  }, _vm._l((_vm.banner), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide",
      attrs: {
        "data-url": item['adUrl']
      }
    }, [_c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": item['adImgUrl'],
        "alt": ""
      }
    })])
  }), 0)], 1), _vm._v(" "), (_vm.loaded) ? _c('div', {
    staticClass: "list-main"
  }, [(!!_vm.curChannelId) ? _c('ul', {
    staticClass: "tab"
  }, _vm._l((_vm.dataSource), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        selectColor: index == _vm.current
      },
      on: {
        "click": function($event) {
          return _vm.onTabItemClick(item, index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n          "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index == _vm.current),
        expression: "index == current"
      }],
      staticClass: "select"
    })])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear: both"
  }), _vm._v(" "), (!_vm.curChannelId) ? _c('div', {
    staticClass: "list-main-title"
  }, [_vm._v("\n        " + _vm._s(_vm.titleAll) + "\n        "), _c('img', {
    attrs: {
      "src": require("../assets/images/button_08.jpg"),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list-main-list relative"
  }, [(_vm.nextShow) ? _c('div', {
    staticClass: "absolute list-main-list-next-page",
    on: {
      "click": _vm.getList
    }
  }, [_c('div', [_vm._v("下一页")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "relative list-main-list-item column",
      attrs: {
        "index": index,
        "data-url": item['id']
      },
      on: {
        "click": function($event) {
          return _vm._link(item['id'])
        }
      }
    }, [_c('div', {
      staticClass: "list-main-list-item-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('ul', [_c('li', [_vm._v(_vm._s(item.shareText))]), _vm._v(" "), _c('li', [_c('div', [_vm._v(_vm._s(item.publishTime))]), _vm._v(" "), _c('div', {
      staticClass: "icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "origin"
    }, [_vm._v("来源：明源云")])])]), _vm._v(" "), _c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.banner,
        "alt": ""
      }
    })])])])
  })], 2)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53bfb74e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list.vue
// module id = 282
// module chunks = 1